// extracted by mini-css-extract-plugin
module.exports = {"container":"Description_container__7sriV","inner":"Description_inner__POHIj"};